
import axios from "axios";
import { Auth_Proto, Auth_Domain, Auth_Port } from "../Component/consts";

const api = axios.create({
    baseURL: `${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters`,
});


export const subscriptionApi = {
    create: (payload) => api.post("/subscriptions", payload),

    getById: (id) => api.get(`/subscriptions/${id}`),
    getByTenant: (tenantId) => api.get(`/subscriptions/tenant/${tenantId}`),

    renew: (payload) => api.post("/subscriptions/renew", payload),
    cancel: (payload) => api.post("/subscriptions/cancel", payload),
    upgrade: (payload) => api.post("/subscriptions/upgrade", payload),
    downgrade: (payload) => api.post("/subscriptions/downgrade", payload),

    // Your controller also exposes this endpoint.
    update: (id, payload) => api.put(`/subscriptions/${id}`, payload),
};

export default subscriptionApi;